import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ButtonLink } from '../../../components/ButtonLink';
import { StatusPanel } from '../../../components/StatusPanel';
import { TextLink } from '../../../components/TextLink';
import { apiErrorMessageKey } from '../../../lib/api';
import { AuthPendingStatus } from '../components/AuthPendingStatus';

export function MagicLinkPending(): ReactElement {
    const { t } = useTranslation();
    return <AuthPendingStatus label={t('AUTH.MAGIC_LINK.PENDING')} />;
}

export function MagicLinkError({ error }: { error: unknown }): ReactElement {
    const { t } = useTranslation();
    return (
        <StatusPanel
            severity="error"
            title={t(apiErrorMessageKey(error, 'ERRORS.MAGIC_LINK_FAILED'))}
            body={
                <Typography variant="body2">
                    <Trans
                        i18nKey="AUTH.MAGIC_LINK.ERROR_HINT"
                        components={{ signInLink: <TextLink to="/login" color="primary" /> }}
                    />
                </Typography>
            }
            action={
                <ButtonLink variant="contained" color="primary" to="/login">
                    {t('AUTH.BACK_TO_SIGN_IN')}
                </ButtonLink>
            }
        />
    );
}
